import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../../constants';
import { ConversationId } from '../../libraries/conversation-id/conversation-id';
import { RequestExecutor } from '../../libraries/request-executor/request-executor';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DirtyWordsService extends RequestExecutor {

  /**
   * Class constructor
   *
   * @param _conversationId
   * @param _httpClient Local instance of HTTP Client
   */
  constructor(
    protected _conversationId: ConversationId,
    protected _httpClient: HttpClient,
  ) {
    super(_conversationId, _httpClient);
  }

  /**
   * Verify if the word is blacklisted or not.
   * @param word
   */
  public verifyDirtyWord(word: string): Observable<any> {
    return this.setRequestHeaders()
      .setRequestParams({
        'text': word
      })
      .executeRequest(
        Constants.REQUEST_TYPE_GET,
        `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.dirtyWords}`
      );
  }
}
